import styled from 'styled-components';
import { color, font, query, space } from '@design/templateFns';
import { VerticalLineSeparator } from '@components/MiscComponents/VerticalLineSeparator';

export const Line = styled.div`
  background: linear-gradient(red, red) no-repeat center/1px 100%;
  display: block;
  height: 100px;
  margin: ${space('x7')};
  @media screen and (${query.atLeast('desktop')}) {
    height: inherit;
    margin: 0;
  }
`;

export const Container = styled.div<{ $reverse?: boolean }>`
  display: flex;
  flex-direction: column;

  @media screen and (${query.atLeast('desktop')}) {
    flex-direction: row;
    flex-wrap: wrap;

    > div:nth-child(even) {
      border-left: 1px solid ${color('cta')};
    }

    > div:nth-child(odd) {
      flex-direction: ${({ $reverse }) => ($reverse ? 'column' : 'column-reverse')};
    }
    > div:nth-child(even) {
      flex-direction: ${({ $reverse }) => ($reverse ? 'column-reverse' : 'column')};
    }
  }
`;

export const StackedItem = styled.div`
  text-align: center;
  width: 100%;
  flex: 0 0 auto;
  margin: 0 auto;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: ${space('x8')};

  @media screen and (${query.atLeast('desktop')}) {
    padding: ${space('x10')} ${space('marginTablet')};
    width: 50%;
    flex: 0 0 auto;
    row-gap: ${space('x14')};
  }
`;

export const StyledVerticalLineSeparator = styled(VerticalLineSeparator)`
  @media screen and (${query.atLeast('desktop')}) {
    display: none;
  }
`;

export const ContentContainer = styled.div<{ $reverse?: boolean }>`
  display: flex;
  justify-content: center;
  flex-direction: column;
  grid-row: 2;
  text-align: center;

  @media screen and (${query.atLeast('tablet')}) {
    margin-top: 0;
    grid-row: ${({ $reverse }) => ($reverse ? 1 : 'unset')};
  }
`;

export const Eyebrow = styled.h3`
  text-transform: uppercase;
  color: ${color('cta')};
  ${font('eyebrow-sm')};
  padding-bottom: 12px;
  margin-top: 0;

  @media screen and (${query.atLeast('desktop')}) {
    ${font('eyebrow-md')};
  }
`;

export const Header = styled.h2`
  ${font('headline-xxs')};
  margin: 0 0 ${space('x5')};
  padding: 0;

  @media screen and (${query.atLeast('tablet')}) {
    ${font('headline-sm')};
  }
`;

export const Text = styled.div`
  color: ${color('fg')};
  padding-bottom: 28px;
  ${font('body-sm-light')};

  @media screen and (${query.atLeast('tablet')}) {
    ${font('body-md-light')};
  }
`;

export const ImageBox = styled.div`
  @media screen and (${query.below('tablet')}) {
    width: 75%;
    height: 0;
    padding-bottom: 75%;
    position: relative;
  }

  img {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
    max-width: 300px;
    max-height: 300px;

    @media screen and (${query.atLeast('tablet')}) {
      max-width: inherit;
      max-height: inherit;
      margin-right: inherit;
      transform: inherit;
      display: inherit;
      position: inherit;
      top: 1px;
      left: 1px;
      object-position: center;
      box-sizing: border-box;
    }
  }
`;

export const CircleImageBox = styled.div`
  img {
    width: 250px;
    height: 250px;
    top: 1px;
    left: 1px;
    object-fit: cover;
    object-position: center;
    border: 8px solid ${color('secondaryBg')};
    box-shadow: 0 0 0 1px ${color('gray2')};
    border-radius: 50%;
    box-sizing: border-box;
  }
`;
